/* ==========================================================================
   Ameda PDP — variant-aware "What's included".

   WHY THIS IS PROGRESSIVE ENHANCEMENT RATHER THAN LIQUID.

   Liquid renders once, on the server, for whatever variant the URL names.
   Shopify's variant picker then changes the selection in the browser without
   a reload. If the contents panel were rendered for one variant only, every
   subsequent variant change would leave a mother reading the pack contents of
   a kit she is not buying — which is a worse failure than the one being
   fixed, because it is silent and it looks correct.

   So every configuration is rendered into the DOM and is visible by default.
   This file hides the ones that are not selected, and only after it has
   positively identified the selected variant. If it cannot — no script, an
   unknown id, a theme change that moves the form — the page falls back to
   showing every configuration, which is exactly what the page does today.
   The failure mode is the current page, never an empty panel.

   IT NEVER DECIDES WHAT IS IN A KIT.

   The panel-to-variant mapping is made in Liquid, by position, and only when
   the number of content blocks equals the number of variants. This file reads
   that mapping and does nothing else. It cannot infer contents, and it will
   not guess when the mapping is absent.
   ========================================================================== */
(function () {
  'use strict';

  var SEL = '.pdt__inc[data-variant-aware="true"]';

  function currentVariantId() {
    // 1. The cart form is authoritative: it is what would actually be bought.
    var input = document.querySelector('form[action*="/cart/add"] input[name="id"]');
    if (input && input.value) return String(input.value).trim();

    // 2. Fall back to the URL, which Shopify keeps in step on variant change.
    try {
      var v = new URL(window.location.href).searchParams.get('variant');
      if (v) return String(v).trim();
    } catch (e) { /* older browsers: fall through */ }

    return null;
  }

  function sync(root) {
    var panels = root.querySelectorAll('.pdt__vpanel');
    if (!panels.length) return;

    var id = currentVariantId();
    if (!id) { stand_down(root, panels); return; }

    var matched = false;
    for (var i = 0; i < panels.length; i++) {
      var hit = panels[i].getAttribute('data-variant-id') === id;
      panels[i].setAttribute('data-active', hit ? 'true' : 'false');
      if (hit) matched = true;
    }

    // An id we do not have a panel for means the mapping no longer describes
    // the product. Show everything rather than nothing.
    if (!matched) { stand_down(root, panels); return; }

    root.classList.add('pdt__inc--live');
  }

  function stand_down(root, panels) {
    root.classList.remove('pdt__inc--live');
    for (var i = 0; i < panels.length; i++) panels[i].setAttribute('data-active', 'true');
  }

  function syncAll() {
    var roots = document.querySelectorAll(SEL);
    for (var i = 0; i < roots.length; i++) sync(roots[i]);
  }

  function start() {
    if (!document.querySelector(SEL)) return;
    syncAll();

    // The picker lives in a different section, so this listens on the document
    // rather than reaching across for an element that may be re-rendered.
    document.addEventListener('change', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      if (!t.closest('variant-selects, variant-radios, .product-form__input, form[action*="/cart/add"]')) return;
      // Let the theme update the hidden input before reading it.
      window.setTimeout(syncAll, 0);
    });

    // Section Rendering API swaps markup in on variant change on some themes.
    ['variant:change', 'variantChange', 'product:variant-change'].forEach(function (name) {
      document.addEventListener(name, function () { window.setTimeout(syncAll, 0); });
    });

    window.addEventListener('popstate', syncAll);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
